// extracted by mini-css-extract-plugin
module.exports = {"root":"BreadCrumbs_root__kprYj","link_item":"BreadCrumbs_link_item__gOjdo"};